import { Component, OnInit } from '@angular/core';
import { StockService } from 'src/app/services/Stock/stock.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from 'moment';

@Component({
  selector: 'app-stock-adjustment',
  templateUrl: './stock-adjustment.component.html',
  styleUrls: ['./stock-adjustment.component.css']
})
export class StockAdjustmentComponent implements OnInit {

  constructor(private stockService:StockService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  StockAdjustmentModel = {
    InventoryCategoryID: 0,
    ItemCategoryID: 0,
    Remarks: '',
    StockID: 0,
    AvailableQty: 0,
    FromDate:'',
    ToDate: ''

}



Clear() {
    this.StockAdjustmentModel.InventoryCategoryID = 0;
    this.StockAdjustmentModel.ItemCategoryID = 0;
    this.StockAdjustmentModel.Remarks = '';
    this.Submitted=false;
};
InventoryCategoryList=[];
GetInventoryCategory() {
  this.lookupService.GetLookupsList('StockInventoryCategory', '').subscribe( (data)=> {
        this.InventoryCategoryList = data.LookupItems;
    });
};
InventoryItemCategoryList=[];
BindInventoryItemCategory() {
    this.spinnerService.show();
    var item = {
        ItemId: this.StockAdjustmentModel.InventoryCategoryID
    }
    this.lookupService.GetLookupsList('StockInventoryItemCategory', JSON.stringify(item)).subscribe( (data)=> {
        this.InventoryItemCategoryList = data.LookupItems;
        this.spinnerService.hide();
    });
}
Validation() {
    return this.StockAdjustmentModel.InventoryCategoryID == 0;
};

Submitted = false;
StockAdjustmentList=[];
GetStockAdjustment() {
    this.Submitted = true;
    if (!this.Validation()) {
       this.spinnerService.show();
        this.stockService.GetStockAdjustment(JSON.stringify(this.StockAdjustmentModel)).subscribe( (data)=> {
          this.spinnerService.hide();
            this.StockAdjustmentList = data.StockAdjustmentList;
            this.globalHelper.CheckActionStatus(data);
        });
    }
};

AdjustmentList=[];
GetAllStockAdjustment() {
  this.spinnerService.show();
  this.StockAdjustmentModel.FromDate =this.StockAdjustmentModel.FromDate!=null && this.StockAdjustmentModel.FromDate!=''?moment(this.StockAdjustmentModel.FromDate).format('DD-MMM-YYYY'):'';
  this.StockAdjustmentModel.ToDate =this.StockAdjustmentModel.ToDate!=null && this.StockAdjustmentModel.ToDate!=''?moment(this.StockAdjustmentModel.ToDate).format('DD-MMM-YYYY'):'';
 
    this.stockService.GetAllStockAdjustment(JSON.stringify(this.StockAdjustmentModel)).subscribe( (data)=> {
      this.spinnerService.hide();
        this.AdjustmentList = data.AdjustmentList;
        this.globalHelper.CheckActionStatus(data);
    });
};

Submitt = false;
UpdateStockAdjustment() {
    this.Submitt = true;
    var countQty = 0;
        for (var i = 0; i < this.StockAdjustmentList.length; i++) {
            if (this.StockAdjustmentList[i].AvailableQty + this.StockAdjustmentList[i].Quantity < 0) {
                return;
            }
            if (this.StockAdjustmentList[i].Quantity != 0 && this.StockAdjustmentList[i].Quantity!=null) {
                countQty = countQty + 1;
                break;
            }
           
        }
       
        if (countQty == 0) {
            return;
        }
       this.spinnerService.show();
        this.stockService.UpdateStockAdjustment(JSON.stringify(this.StockAdjustmentModel), JSON.stringify(this.StockAdjustmentList)).subscribe( (data)=> {
          this.spinnerService.hide();
          this.globalHelper.CheckActionStatus(data);
            this.GetAllStockAdjustment();
            if (data.webResponse.Status) {
                this.Clear();

            }
        });
    
};


  ngOnInit() {
    this.GetInventoryCategory();
    this.GetAllStockAdjustment();
  }


  // Print

  PrintStockAdjustment(StockAdjustID) {
    var url = "stockadjustmentprint?StockAdjustID=" + StockAdjustID;   
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
};

}
